import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private headerNameSubject = new BehaviorSubject<string>('');
  public headerName$ = this.headerNameSubject.asObservable();

  private onReturnSubject = new BehaviorSubject<void>(null);
  public onReturn$ = this.onReturnSubject.asObservable();

  setHeaderName(name: string) {
    this.headerNameSubject.next(name);
  }

  getHeaderName(): string {
    return this.headerNameSubject.value;
  }

  triggerReturn() {
    this.onReturnSubject.next();
  }
}
